import { MenuItem } from 'primeng/api';

export const homeBreadcrumbsConfig: MenuItem = {
  icon: 'pi pi-home',
  title: 'navigation.dashboard.label',
  id: 'dashboard',
  routerLink: '/panel/dashboard',
};
